var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevelopmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.494 0.13125C29.3475 2.18575 35.8855 8.6765 38.5 12.173C36.2495 10.598 31.423 9.27325 27.8408 10.1097C28.2292 7.54075 27.517 2.17525 25.494 0.13125ZM38.5 19.25V42H3.5V0H18.2158C26.7155 0 24.052 14 24.052 14C29.3178 12.6962 38.5 13.2668 38.5 19.25ZM19.25 21L10.5 24.8517V27.65L19.25 31.5V28.6073L13.5992 26.25L19.25 23.8857V21ZM31.5 24.8517L22.75 21V23.8857L28.4007 26.25L22.75 28.6073V31.5L31.5 27.6483V24.8517Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopmentIcon);
export default __webpack_public_path__ + "static/media/developmentIcon.5cfbc505f552f5f32efc684c129127db.svg";
export { ForwardRef as ReactComponent };